// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__1yE_T","col":"styles_col__2APDd"};